<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver al listado de inspecciones de la U.I.">
            <i class="fa fa-chevron-left"></i></button>

        <button *ngIf="hasSavingAccess && !visibilitySpinnerGuardando" type="button" 
            [disabled]="actionNotAllowed" class="btn btn-outline-success" (click)="onClickSave()" title="Guardar {{ title.singular }}">
            <i class="fa fa-save"></i> Guardar {{ title.singular }}</button>

        <button *ngIf="visibilitySpinnerGuardando" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Guardando
        </button>
    </form>
</nav>

<div class="container-fluid container-list">
    
    <div class="row">
        <div *ngIf="listaPlazosPeriodo" class="ms-1 nota-info col-3 col-lg-5">
            <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> Fecha Fin del Periodo: {{ listaPlazosPeriodo.PeriodoFechaFin | date: 'dd/MM/yyyy HH:mm' }}</label>
        </div>
        <div *ngIf="!habilitadaExportacion" class="ms-1 nota-info col-3 col-lg-4">
            <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> Exportación habilitada: {{ habilitadaExportacion | siNo }}</label>
        </div>
        <ng-container *ngIf="habilitadaExportacion">
            <div *ngIf="listaPlazosPeriodo && fechaInicioExportacionVigente" class="ms-1 nota-info col-3 col-lg-5">
                <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> Fecha Inicio de Exportación: {{ fechaInicioExportacionVigente | date: 'dd/MM/yyyy HH:mm' }}</label>
            </div>
            <div *ngIf="listaPlazosPeriodo && !fechaInicioExportacionVigente" class="ms-1 nota-info warning col-3 col-lg-6">
                <label class="col-form-label" for=""><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Fecha Inicio de Exportación: No hay plazo de exportación vigente.</label>
            </div>
        </ng-container>
    </div>

    <app-unidad-inspeccion-header *ngIf="unidadInspeccion?.FirstRecinto" [formGroup]="formGroupHeader" [unidadInspeccion]="unidadInspeccion"></app-unidad-inspeccion-header>

    <app-inspeccion-ui-edit 
        [readonly]="readonly" [inspeccion]="inspeccion" [listaInspeccionPeriodo]="listaInspeccionPeriodo" [resultadosInspeccion]="resultadosInspeccion" [formGroup]="formGroupInspeccion"
        [IdTipoSolicitudCam]="unidadInspeccion?.FirstRecinto?.IdTipoSolicitudCam"
        (tipoInspeccionSelected)="onTipoInspeccionSelected($event)"
    ></app-inspeccion-ui-edit>
</div>